import Span from "./span";
import { registerFormatType } from '@wordpress/rich-text';


registerFormatType( 'gutenberg-span/span-output', Span );